import React, { useEffect, useState } from "react";
// React Table
import { Table } from "react-bootstrap";
// Styled Components
import styled from "styled-components";

import { dateToString, dateToString2 } from "../../../utils";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaMisionExtra = ({ misionExtra }) => {

  return (
    <Table bordered responsive>
      <tbody>
      {misionExtra?.lugar && (
          <tr>
            <CustomTd>
              <span>Lugar</span>
            </CustomTd>
            <td >{misionExtra.lugar || <small>No especificado</small>}</td>
            <CustomTd>
              <span>Nivel</span>
            </CustomTd>
            <td >{misionExtra.nivel || <small>No especificado</small>}</td>
          </tr>
        )}
        <tr>
          <CustomTd className={"w-25"}>
            <span>Fecha de inicio</span>
          </CustomTd>
          <td>{dateToString(misionExtra?.startDate) || <small>No especificado</small>}</td>

          <CustomTd >
            <span>Fecha de término</span>
          </CustomTd>
          <td>{dateToString(misionExtra?.endDate) || <small>No especificado</small>}</td>
        </tr>

        {misionExtra?.cargo && (
          <tr>
            <CustomTd >
              <span>Misión</span>
            </CustomTd>
            <td colSpan={3}>{misionExtra?.cargo || <small>No especificado</small>}</td>
          </tr>
        )}
        {misionExtra?.descripcion && (
          <tr>
            <CustomTd>
              <span>Descripción</span>
            </CustomTd>
            <td colSpan={3}>{misionExtra.descripcion || <small>No especificado</small>}</td>
          </tr>
        )}

      </tbody>
    </Table>
  );
};

export default VistaMisionExtra;
